import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions';
// import {DetailsType} from '__utils/type';

export interface InvestorProfileState {
    isPinCodeVerified: any;
    fetchPinCodeError: any;
}
const rawState: InvestorProfileState = {
    isPinCodeVerified: "",
    fetchPinCodeError: ""

};

const intialState = fromJS(rawState);

export default function personalDetailsReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.FETCH_GET_VERIFY_PINCODE_SUCCESS:
            return merge(state, fromJS({ isPinCodeVerified: action.payload}));
        case Actions.FETCH_GET_VERIFY_PINCODE_ERROR:
            return merge(state, fromJS({ fetchPinCodeError: action.payload.data}));
        default:
            return state;
    }
}
